@if (show) {
  <div
    class="flex justify-between mr-4 align-content-center">
    <span class="text-base font-bold md:text-3xl">{{ providerGroup.groupingKey }}</span>
    <span class="hidden font-bold md:block icn icn-stack text-th-primary align-items-center">
    {{ providerGroup.services.length }} procedures</span>
  </div>
}
